
import { defineComponent } from 'vue';
import { bool, object, string } from 'vue-types';
import { Camera } from '@/api';
import CameraStatusBrief from './CameraStatusBrief.vue';
import CameraStatusInfo from "@/components/data-source/CameraStatusInfo.vue";

export default defineComponent({
  name: 'CameraStatus',
  components: {
    CameraStatusInfo,
    CameraStatusBrief,
  },
  props: {
    camera: object<Camera>().isRequired,
    showStatusLabel: bool().def(true),
    statusType: string().def('circle'),
  },
  computed: {
    statusLabel() {
      return this.$t('ds.status__' + (this.camera.health_status?.status || '').toLowerCase(), 'f');
    }
  }
});
